import React, { FC, memo } from 'react'
import { useToggle } from '@ucheba/utils/hooks/useToggle'
import SC from '../base/CollapseItem'
import { ICollapseItemProps } from '../types'
import MinusIcon from '../../../icons/icon__minus.svg'
import PlusIcon from '../../../icons/icon__plus.svg'
import { Text } from '../../Text/desktop'

const { Block, Inner, Activator, Icon } = SC

/** Итем коллапса */
const CollapseItem: FC<ICollapseItemProps> = (props) => {
  const {
    children,
    title,
    open = false,
    className,
    OverTitle,
    marginLeft = 0,
    fontSize = 'h3',
    lineHeight = 'h3',
    fontWeight = 'bold',
    ...otherProps
  } = props

  const [isOpen, toggleOpen] = useToggle(open)

  return (
    <Block className={className}>
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore */}
      <div {...otherProps}>
        {OverTitle}

        <Activator onClick={toggleOpen}>
          {title && (
            <>
              {typeof title === 'string' ? (
                <Text fontWeight={fontWeight} lineHeight={lineHeight} fontSize={fontSize}>
                  {title}
                </Text>
              ) : (
                title
              )}
            </>
          )}

          <Icon as={isOpen ? MinusIcon : PlusIcon} />
        </Activator>

        <Inner open={isOpen} marginLeft={marginLeft}>
          {children}
        </Inner>
      </div>
    </Block>
  )
}

export { CollapseItem }
export default memo(CollapseItem)
